var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "transferMultiTree" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ]
      },
      [
        _c("tree-email", {
          ref: "tree",
          attrs: {
            lazy: "",
            load: _vm.loadNode,
            data: _vm.model,
            props: _vm.defaultProps,
            "check-on-click-node": false,
            "node-key": "keyId",
            "show-page-btn": "nextPage",
            "show-checkbox": true,
            "expand-on-click-node": true,
            "highlight-current": "",
            "check-strictly": true
          },
          on: {
            "check-change": _vm.changeCheckStatus,
            "node-next-page": _vm.getNextPageNode
          },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function(ref) {
                  var node = ref.node
                  var data = ref.data
                  return _vm.openPanel
                    ? _c("span", { staticStyle: { width: "85%" } }, [
                        _c("div", {
                          staticClass: "tree-icon-position",
                          class: [
                            data.appName
                              ? _vm.returnName(data.appName)
                              : "small-file",
                            data.dir
                              ? data.docType == "thread"
                                ? "ic-forder"
                                : "folder-small folder-option-icon"
                              : "",
                            !data.dir && !data.appName
                              ? _vm.matchfileType(data.name) +
                                "-small folder-option-icon"
                              : ""
                          ]
                        }),
                        _vm._v(" "),
                        data.docType != "thread"
                          ? _c(
                              "div",
                              {
                                staticClass: "node-name",
                                attrs: { title: node.label }
                              },
                              [_vm._v(_vm._s(_vm._f("ellipsis")(node.label)))]
                            )
                          : _c("div", {
                              staticClass: "node-name email-message",
                              attrs: { title: data.subject },
                              domProps: { innerHTML: _vm._s(data.message) }
                            })
                      ])
                    : _vm._e()
                }
              }
            ],
            null,
            true
          )
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-986b7d26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-986b7d26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/trees/transfer_multi_email_tree.vue
// module id = null
// module chunks = 